package main.kotlin.models

import main.kotlin.ui.Div
import main.kotlin.ui.TopNavBarTab
import org.w3c.dom.Document

abstract class LeftSectionedScreen(document: Document,tab: TopNavBarTab?=null) : TopNavBarScreen(document,tab)
{
    override val content = Div(document,"page_content","flex")
}